import { MaintenanceWindowFormBaseDataProvider } from './MaintenanceWindowFormBaseDataProvider';
import { MaintenanceWindowData, MaintenanceWindowTypeData } from '../types';
import { sanitizeArray, sanitizeObject } from '../../../utils/sanitization.utils';
import { getRequestDefaultOptions } from '../../../utils/request.utils';
import { DbToUiValuesConverter } from '../../../utils/maintenanceWindow/patchManagement/DbToUiValuesConverter';

export class MaintenanceWindowFormGzDataProvider extends MaintenanceWindowFormBaseDataProvider {
  public async getMaintenanceWindow(maintenanceWindowId: string): Promise<MaintenanceWindowData> {
    try {
      const result = await this.dependencies.api.clients.MaintenanceWindows.getRecord(maintenanceWindowId);
      if (!result || typeof result.data === undefined) {
        throw new Error('Invalid response of getMaintenanceWindowById');
      }

      const maintenanceWindow: MaintenanceWindowData = DbToUiValuesConverter.prepareUiData(result.data);
      return maintenanceWindow;
    } catch (e) {
      console.error(e);
      throw e;
    }
  }

  public async createMaintenanceWindow(record: Object): Promise<Object | null> {
    try {
      const response = await this.dependencies.api.clients.MaintenanceWindows.createRecords(
        record,
        getRequestDefaultOptions()
      );

      return sanitizeObject(response);
    } catch (e) {
      console.error(e);
      throw e;
    }
  }

  public async updateMaintenanceWindow(record: Object): Promise<Object | null> {
    try {
      const response = await this.dependencies.api.clients.MaintenanceWindows.updateRecords(
        record,
        getRequestDefaultOptions()
      );

      return sanitizeObject(response);
    } catch (e) {
      console.error(e);
      throw e;
    }
  }

  public async getMaintenanceWindowsTypes(): Promise<MaintenanceWindowTypeData[]> {
    const data = await this.dependencies.api.clients.MaintenanceWindows.getMaintenanceWindowsTypes();

    return sanitizeArray(data);
  }

  public async getSuggestedNewMaintenanceWindowName(type: number): Promise<string> {
    const maintenanceWindowSuggestedName =
      await this.dependencies.api.clients.MaintenanceWindows.getSuggestedNewMaintenanceWindowName(
        type,
        this.dependencies.getActiveCompany().companyId
      );
    return maintenanceWindowSuggestedName;
  }
}
